//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportStudentIDsInputItem } from './IReportStudentIDsInputItem';
import { ReportType } from './Enums';

export class RepertoireReportInputItem extends ReportInputItem implements IReportStudentIDsInputItem {
    RepertoireIDs: string[] = [];
    StudentIDs: string[] = [];
    IncludeRequested: boolean = false;
    IncludeRecommended: boolean = false;
    IncludeInProgress: boolean = false;
    IncludeCompleted: boolean = false;
    IncludeNotes: boolean = false;
    IncludeDuration: boolean = false;
    override readonly Type: ReportType = ReportType.Repertoire;

    constructor(initializer?: Partial<Omit<RepertoireReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "RepertoireReportInputItem";
}
